"use client";

import { useTranslations } from "next-intl";

import { chatErrorKind } from "@/lib/ai/chat-ui";

export function useChatErrorText(): (raw: string, own?: boolean) => string {
  const t = useTranslations("site.chat.error");

  return (raw, own = false) => {
    const kind = chatErrorKind(raw, own);
    return kind ? t(kind) : raw.trim();
  };
}
